/* eslint-disable no-unused-vars */
export enum LOG_TYPE {
  CLEVER_TAP = 'clever_tap',
  GA = 'ga'
}

export const EventNames = {
  HELP_CENTER_SUBMIT: 'helpCentreSubmit',
  STORE_REVIEW_CLICKED: 'storeReviewClicked',
  REFER_EARN: 'referEarn',
  PARTNER_PERMISSION: 'partner_permission',
  NEW_ENQUIRY: 'newEnquiry',
  TRACK_TRANSFER: 'trackTransfer',
  HC_SEARCH_EVENT: 'helpCenterSearchBarText',
  HC_BROWSE_EVENT: 'helpCenterIssuePopularity',
  COMPARE_TABLE: 'rateCompareTable',
  TRANSACTION_AUTHORIZATION_STARTED: 'transactionAuthorizationStarted',
  SUMMARY_PAY_IN_DISCOVERY: 'summaryPayInDiscovery',
  NF_CROSS_SELLING: {
    baseName: 'leadGeneration',
    discovery: 'Discovery',
    explore: 'Explore',
    interestSubmission: 'InterestSubmission',
    goHome: 'GoToHome'
  },
  HELP_CENTER_INITIATED: 'helpCenterInitiated',
  PROFILE_SECTION_HELP_CENTER: 'profileSectionHelpCentre',
  HELP_CENTER_ALL_TICKETS: 'helpCenterAllTickets',
  HELP_CENTER_TAB: 'helpCentreTab',
  HELP_CENTER_ACTIVE_CHAT: 'helpCenterActiveChat',
  HELP_CENTER_OPEN_TICKET: 'helpCenterOpenTicket',
  LARGE_TRANSACTION_REQUEST: 'largeTransactionRequest',
  LARGE_TRANSACTION_REQUEST_SUBMIT: 'largeTransactionRequestSubmit',
  LARGE_TRANSACTION_REQUEST_CALLBACK: 'largeTransactionRequestCallback',
  LARGE_TRANSACTION_REQUEST_DROP: 'largeTransactionRequestDrop',
  Error: 'Error'
};

export const FLOW_TYPE = {
  PORFILE_SECTION_HELP_CENTER: 'profile_section_help_centre',
  LOGIN: 'login',
  SIGNUP: 'signUp',
  TRANSACTION_HISTORY: 'transactionHistory',
  HELP_CENTER: 'helpCenter',
  TRANSACTION_FLOW: 'transactionFlow',
  NF_CROSS_SELLING: 'niumForexCrossSelling',
  HIGH_VOLUME_TRANSACTION_FLOW: 'highVolumeTransactionFlow',
  BENEFICIARY: 'beneficiary',
  EDIT_BENE: 'editBene',
  INSTAPOINT: 'instapoint',
  SEND_MONEY: 'sendMoney',
  AMAZE: 'amaze',
  REFERRALS: 'referrals',
  DASHBOARD: 'dashboard',
  SETTINGS: 'settings',
  LOGOUT: 'logout',
  MANAGE_PAYMENT_OPTIONS: 'managePaymentOptions',
  MY_INFO: 'myInfo',
  DASHBOARD_MENU: 'dashboardMenu',
  PROMOTIONAL: 'promotional',
  DHA_FLOW: 'dhaFlow'
};
export const PRODUCT_TYPE = {
  DHA_PAYMENTS: 'dhaPayments'
};

// Event names for tracking user actions.
export enum EventNamesV2 {
  SCREEN_VIEWED = 'screenViewed',
  CTA_CLICKED = 'ctaClicked',
  ITEM_CLICKED = 'itemClicked',
  CARD_CLICKED = 'cardClicked',
  API_CALLS = 'apiCalls',
  SDK_INITIALIZED = 'sdkInitialized',
  PERMISSION = 'permission',
  MODAL_VIEWED = 'modalViewed',
  SEARCH_BAR = 'searchBar',
  PROGRESS_UPDATED = 'progressUpdated',
  RECIPIENT_UPDATED = 'recipientUpdated',
  RECIPIENT_ADDED = 'recipientAdded'
}

// Types of buttons involved in events.
export enum EventButtonType {
  BUTTON = 'button',
  LINK = 'link',
  ICON = 'icon',
  BACK = 'back',
  EXIT = 'exit',
  CROSS = 'cross',
  INFO = 'info',
  TOOLTIP = 'tooltip',
  MESSAGE_CENTER = 'messageCenter',
  UPWARD_ARROW = 'upwardArrow',
  DOWNWARD_ARROW = 'downwardArrow',
  SEARCH = 'searchBar'
}

// Different modal types.
export enum EventModalType {
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
  INFORMATION = 'information',
  DISCOVERY = 'discovery'
}

export enum PAGE_NAMES {
  DASHBOARD = 'dashboard',
  PROMOTIONS = 'promotions',
  ADD_BENE = 'addBene',
  SEND_MONEY = 'sendMoney',
  EDIT_BENE = 'editBene',
  INSTAPOINT_DASHBOARD = 'instapointDashboard',
  REFER_AND_EARN = 'referAndEarn',
  PAYMENT_METHOD = 'paymentMethod',
  PAYEE_LIST = 'recepientList',
  TRANSACTION_HISTORY = 'transactionHistory',
  SIGNIN = 'signin',
  PROFILE = 'profile',
  MANAGE_PAYMENT_OPTION = 'paymentOption',
  SUBSCRIBE = 'subscribe',
  HELP_CENTER = 'helpCenter',
  LOGOUT = 'logOut',
  AMAZE = 'amaze'
}

export enum EventItemSection {
  PAYMENT_METHOD = 'paymentMethod',
  BANK_SELECTION = 'bankSelection',
  DROPDOWN = 'dropdown',
  TABS = 'tabs',
  CARD = 'card',
  ADDRESS_VERIFICATION = 'addressVerification',
  BENEFICIARY = 'beneficiary',
  BENE_RECEIVING_METHOD = 'beneReceivingMethod',
  EDIT_BENE = 'editBeneIcon',
  DETAILS = 'detailsCta',
  ADD_RECEPIENT = 'addRecepient',
  SEND_NOW = 'sendNow',
  SEARCH = 'searchBar',
  EARN_INSTAPOINTS = 'EarnInstapoints',
  GET_APP = 'GetApp',
  INSTAPOINTS_HISTORY = 'InstapointsHistory',
  LIST = 'list',
  BANK_ACCOUNT_TYPE = 'bankAccountType',
  CONFIRM = 'confirm',
  CONTINUE = 'continue',
  DHA_CHALLAN_VERIFIED = 'dhaChallanVerified'
}

export const EVENT_ROUTE_KEYS = {
  AddBeneficiary: 'AddBeneficiary',
  EditBeneficiary: 'EditBeneficiary',
  PayeeList: 'BeneficiaryList',
  AdressPage: 'BeneficiaryAddressPage',
  AddressCollectionPage: 'BeneAddressCollectionPage',
  Instapoints: 'Instapoints',
  InstapointsHistoryPage: 'InstapointsHistoryPage',
  AmazeLandingPage: 'AmazeLandingPage',
  ReferAndEarn: 'ReferAndEarnPage',
  Settings: 'Settings',
  Dashboard: 'Dashboard',
  ReferralHistory: 'ReferralHistory',
  ManagePaymentOptions: 'ManagePaymentOptions',
  UserProfile: 'MyInfoPage',
  SendMoney: 'SendMoney',
  sendMoney: 'sendMoney',
  DHAFlow: 'DHAFlow',
  Subscriptions: 'Subscriptions',
  FatzebraSDK: 'FatzebraSDK'
};

export const ProgressType = {
  API_RESPONSE: 'ApiResponse',
  SDK_RESPONSE: 'SdkResponse'
};
